import { InvalidArgumentError } from '@commander-js/extra-typings';
import { pureHeadlessTemplates } from '../parse-command-options.js';

export function validateSiteTemplate(value: string): string {
  const normalized = value.trim().toLowerCase();
  const match = pureHeadlessTemplates.find(
    (template) => template.name === normalized
  );

  if (!match) {
    const available = pureHeadlessTemplates
      .map((template) => template.name)
      .join(', ');
    throw new InvalidArgumentError(
      `Unknown template "${value}". Available templates: ${available}`
    );
  }

  return match.name;
}
